import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { incrementQuestionViews, fetchQuestions } from "../../store/questionsSlice";
import { Box, Typography, Divider } from "@mui/material";
import "./QARightSection.css";

function Section({ title, items, loading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Box className="qaRightCard">
      <Box className="qaRightHeader">
        <Typography variant="h5">{title}</Typography>
        <img
          src={process.env.PUBLIC_URL + "/images/Home/arrow-right.png"}
          alt="arrow"
          className="qaArrowIcon"
        />
      </Box>

      <Divider />

      <Box className="qaList">
        {loading ? (
          <Typography sx={{ p: 2, fontSize: "14px", color: "#777" }}>
            Loading...
          </Typography>
        ) : items.length === 0 ? (
          <Typography sx={{ p: 2, fontSize: "14px", color: "#777" }}>
            No queries found
          </Typography>
        ) : (
          items.map((q) => (
            <Typography
              key={q.id}
              className="qaListItem"
              onClick={() => {
                dispatch(incrementQuestionViews(q.id));
                navigate(`/queries/${q.id}`);
              }}
            >
              {q.body}
            </Typography>
          ))
        )}
      </Box>
    </Box>
  );
}

export default function QARightSection() {

  const dispatch = useDispatch();
  const [sidebarLoading, setSidebarLoading] = useState(true);
  const { activeQuestions, unansweredQuestions } = useSelector(
    (state) => state.questions
  );

  useEffect(() => {
    const loadSidebarData = async () => {
      try {
        setSidebarLoading(true);
        await dispatch(fetchQuestions({ type: "active", source: "sidebar" }));
        await dispatch(fetchQuestions({ type: "unanswered", source: "sidebar" }));
      } catch (error) {
        console.error("Sidebar fetch error:", error);
      } finally {
        setSidebarLoading(false);
      }
    };

    loadSidebarData();
  }, [dispatch]);

  const activeQueries = (activeQuestions || []).slice(0, 5);
  const unansweredQueries = (unansweredQuestions || []).slice(0, 5);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Section title="Active Queries" items={activeQueries || []} loading={sidebarLoading} />
      <Section title="Unanswered Queries" items={unansweredQueries || []} loading={sidebarLoading} />
    </Box>
  );
}
